import { IntegrationsType, TBarType } from "../utilities/constants";
import { BundleTypes } from "./Bundles/constants";
import {
    DefaultVariantType,
    VariantsObj,
    StepConditionType,
    StepsType,
    BundleBuilderConfigInterface,
    ProductObj,
    PlaceholderConfigInterface,
    PlaceholderStepsType,
} from "./Bundles/Types";

export const MAX_LENGTH_MOBILE = 20;
export const MAX_LENGTH_DESKTOP = 40;
export const PAGE_SIZE = 10;

export const AllowedShops = [
    "quickstart-d39966c5.myshopify.com",
    "kefitest.myshopify.com",
    "kefi-templates.myshopify.com",
    "quickstart-995da7b7.myshopify.com",
    "a0d3f6-0f.myshopify.com",
    "testing-kefi.myshopify.com",
    "bundle-test3.myshopify.com",
    "sec11.myshopify.com",
];

export const BarTypes: Record<string, TBarType> = {
    SHIPPING_BAR: "1",
    ANNOUNCEMENT_BAR: "2",
    COUNTDOWN_BAR: "3",
    EMAIL_COLLECTION_BAR: "4",
};

export const IntegrationTypes: Record<string, IntegrationsType> = {
    KLAVIYO: "1",
    SHOPIY_EMAILS: "2",
};

export const getBarType: (barType: any) => string = (barType = null) => {
    let obj = "-";
    if (!barType) {
        return obj;
    }
    const type = +barType;
    switch (type) {
        case 1:
            obj = "Free Shipping Bar";
            break;
        case 2:
            obj = "Announcement Bar";
            break;
        case 3:
            obj = "Countdown Bar";
            break;
        case 4:
            obj = "Email Collection Bar";
            break;
        default:
            obj = "-";
    }
    return obj;
};

export const getBarRoute = (type = 0, id: string = "") => {
    let route = "/";
    switch (type) {
        case 1:
            route = id ? "/fsb?form_id=" + id : "/fsb";
            break;
        case 2:
            route = id ? "/acb?form_id=" + id : "/acb";
            break;
        case 3:
            route = id ? "/cdb?form_id=" + id : "/cdb";
            break;
        case 4:
            route = id ? "/ecb?form_id=" + id : "/ecb";
            break;
        default:
            route = "/";
    }
    return route;
};

export const getBundleType: (barType: any) => string = (barType = "") => {
    let obj = "-";
    if (!barType) {
        return obj;
    }
    const type = barType;
    switch (type) {
        case BundleTypes.BXGY:
            obj = "Buy X Get Y";
            break;
        case BundleTypes.STANDARD:
            obj = "Standard Bundle";
            break;
        case BundleTypes.VOLUME_DISCOUNT:
            obj = "Quantity Breaks";
            break;
        case BundleTypes.MIX_MATCH:
            obj = "Mix & Match";
            break;
        case BundleTypes.MIX_MATCH_SECTIONAL:
            obj = "Mix & Match (Sectional)";
            break;
        case BundleTypes.FBT:
            obj = "Frequently Bought Together";
            break;
        case BundleTypes.PRODUCT_ADDONS:
            obj = "Product Add-on";
            break;
        case BundleTypes.PRODUCT_ADDONS_POPUP:
            obj = "Product Add-ons (Popup)";
            break;
        case BundleTypes.BUNDLE_BUILDER:
            obj = "Bundle Builder";
            break;
        case BundleTypes.BUY_N:
            obj = "Buy N, Discount on Cheapest / Costliest";
            break;
        case BundleTypes.BB_PLACEHOLDER:
            obj = "Product Page Bundle Builder";
            break;
        default:
            obj = "-";
    }
    return obj;
};

export const getBundleRoute = (type = "", id: string = "") => {
    let route = "/";
    switch (type) {
        case BundleTypes.BXGY:
            route = "/bxgy/" + id;
            break;

        case BundleTypes.MIX_MATCH:
            route = "/mixmatch/" + id;
            break;
        case BundleTypes.MIX_MATCH_SECTIONAL:
            route = "/mixmatch-sectional/" + id;
            break;
        case BundleTypes.STANDARD:
            route = "/standard/" + id;
            break;
        case BundleTypes.VOLUME_DISCOUNT:
            route = "/quantity-break/" + id;
            break;
        case BundleTypes.FBT:
            route = "/fbt/" + id;
            break;
        case BundleTypes.PRODUCT_ADDONS:
            route = "/product_add_on/" + id;
            break;
        case BundleTypes.AI_BUNDLES:
            route = "/ai-bundles/" + id;
            break;
        case BundleTypes.BUNDLE_BUILDER:
            route = "/bundle-builder/byob/" + id;
            break;
        case BundleTypes.BB_PLACEHOLDER:
            route = "/bundle-builder/placeholder/" + id;
            break;
        case "slide-cart":
            route = "/slide-cart/" + id;
            break;
        case "thank-you-page":
            route = "/thank-you-page/" + id;
            break;
        case BundleTypes.OFFERS:
            route = "/bundles";
            break;
        case "post-purchase":
            route = "/post-purchase/" + id;
            break;
        case BundleTypes.PRODUCT_ADDONS_POPUP:
            route = "/product_add_on_popup/" + id;
            break;
        case BundleTypes.BUY_N:
            route = "/buy-n/" + id;
            break;
        default:
            route = "/";
    }
    return route;
};
export const CurrencyTypes = [
    {
        country: "Afghan Afghani",
        country_code: "AFN",
        symbol: "؋",
    },
    {
        country: "Albanian Lek",
        country_code: "ALL",
        symbol: "L",
    },
    {
        country: "Algerian Dinar",
        country_code: "DZD",
        symbol: "دج",
    },
    {
        country: "Angolan Kwanza",
        country_code: "AOA",
        symbol: "Kz",
    },
    {
        country: "Argentine Peso",
        country_code: "ARS",
        symbol: "$",
    },
    {
        country: "Armenian Dram",
        country_code: "AMD",
        symbol: "֏",
    },
    {
        country: "Australian Dollar",
        country_code: "AUD",
        symbol: "$",
    },
    {
        country: "Azerbaijani Manat",
        country_code: "AZN",
        symbol: "₼",
    },
    {
        country: "Bahamian Dollar",
        country_code: "BSD",
        symbol: "$",
    },
    {
        country: "Bahraini Dinar",
        country_code: "BHD",
        symbol: ".د.ب",
    },
    {
        country: "Bangladeshi Taka",
        country_code: "BDT",
        symbol: "৳",
    },
    {
        country: "Barbadian Dollar",
        country_code: "BBD",
        symbol: "$",
    },
    {
        country: "Belarusian Ruble",
        country_code: "BYN",
        symbol: "Br",
    },
    {
        country: "Belize Dollar",
        country_code: "BZD",
        symbol: "$",
    },
    {
        country: "Bermudian Dollar",
        country_code: "BMD",
        symbol: "$",
    },
    {
        country: "Bhutanese Ngultrum",
        country_code: "BTN",
        symbol: "Nu.",
    },
    {
        country: "Bolivian Boliviano",
        country_code: "BOB",
        symbol: "Bs.",
    },
    {
        country: "Bosnia-Herzegovina Convertible Mark",
        country_code: "BAM",
        symbol: "KM",
    },
    {
        country: "Botswana Pula",
        country_code: "BWP",
        symbol: "P",
    },
    {
        country: "Brazilian Real",
        country_code: "BRL",
        symbol: "R$",
    },
    {
        country: "British Pound Sterling",
        country_code: "GBP",
        symbol: "£",
    },
    {
        country: "Brunei Dollar",
        country_code: "BND",
        symbol: "$",
    },
    {
        country: "Bulgarian Lev",
        country_code: "BGN",
        symbol: "лв",
    },
    {
        country: "Burundian Franc",
        country_code: "BIF",
        symbol: "FBu",
    },
    {
        country: "Cabo Verdean Escudo",
        country_code: "CVE",
        symbol: "$",
    },
    {
        country: "Cambodian Riel",
        country_code: "KHR",
        symbol: "៛",
    },
    {
        country: "Canadian Dollar",
        country_code: "CAD",
        symbol: "$",
    },
    {
        country: "Cayman Islands Dollar",
        country_code: "KYD",
        symbol: "$",
    },
    {
        country: "Central African CFA Franc",
        country_code: "XAF",
        symbol: "Fr",
    },
    {
        country: "Chilean Peso",
        country_code: "CLP",
        symbol: "$",
    },
    {
        country: "Chinese Yuan",
        country_code: "CNY",
        symbol: "¥",
    },
    {
        country: "Colombian Peso",
        country_code: "COP",
        symbol: "$",
    },
    {
        country: "Comorian Franc",
        country_code: "KMF",
        symbol: "Fr",
    },
    {
        country: "Congolese Franc",
        country_code: "CDF",
        symbol: "Fr",
    },
    {
        country: "Costa Rican Colón",
        country_code: "CRC",
        symbol: "₡",
    },
    {
        country: "Croatian Kuna",
        country_code: "HRK",
        symbol: "kn",
    },
    {
        country: "Cuban Peso",
        country_code: "CUP",
        symbol: "$",
    },
    {
        country: "Czech Koruna",
        country_code: "CZK",
        symbol: "Kč",
    },
    {
        country: "Danish Krone",
        country_code: "DKK",
        symbol: "kr",
    },
    {
        country: "Djiboutian Franc",
        country_code: "DJF",
        symbol: "Fdj",
    },
    {
        country: "Dominican Peso",
        country_code: "DOP",
        symbol: "$",
    },
    {
        country: "East Caribbean Dollar",
        country_code: "XCD",
        symbol: "$",
    },
    {
        country: "Egyptian Pound",
        country_code: "EGP",
        symbol: "£",
    },
    {
        country: "Eritrean Nakfa",
        country_code: "ERN",
        symbol: "Nfk",
    },
    {
        country: "Estonian Kroon",
        country_code: "EEK",
        symbol: "kr",
    },
    {
        country: "Ethiopian Birr",
        country_code: "ETB",
        symbol: "Br",
    },
    {
        country: "Euro",
        country_code: "EUR",
        symbol: "€",
    },
    {
        country: "Fijian Dollar",
        country_code: "FJD",
        symbol: "$",
    },
    {
        country: "Gambian Dalasi",
        country_code: "GMD",
        symbol: "D",
    },
    {
        country: "Georgian Lari",
        country_code: "GEL",
        symbol: "₾",
    },
    {
        country: "Ghanaian Cedi",
        country_code: "GHS",
        symbol: "₵",
    },
    {
        country: "Gibraltar Pound",
        country_code: "GIP",
        symbol: "£",
    },
    {
        country: "Guatemalan Quetzal",
        country_code: "GTQ",
        symbol: "Q",
    },
    {
        country: "Guinean Franc",
        country_code: "GNF",
        symbol: "FG",
    },
    {
        country: "Guyanese Dollar",
        country_code: "GYD",
        symbol: "$",
    },
    {
        country: "Haitian Gourde",
        country_code: "HTG",
        symbol: "G",
    },
    {
        country: "Honduran Lempira",
        country_code: "HNL",
        symbol: "L",
    },
    {
        country: "Hong Kong Dollar",
        country_code: "HKD",
        symbol: "$",
    },
    {
        country: "Hungarian Forint",
        country_code: "HUF",
        symbol: "Ft",
    },
    {
        country: "Icelandic Króna",
        country_code: "ISK",
        symbol: "kr",
    },
    {
        country: "Indian Rupees",
        country_code: "INR",
        symbol: "₹",
    },
    {
        country: "Indonesian Rupiah",
        country_code: "IDR",
        symbol: "Rp",
    },
    {
        country: "Iranian Rial",
        country_code: "IRR",
        symbol: "﷼",
    },
    {
        country: "Iraqi Dinar",
        country_code: "IQD",
        symbol: "ع.د",
    },
    {
        country: "Israeli New Shekel",
        country_code: "ILS",
        symbol: "₪",
    },
    {
        country: "Jamaican Dollar",
        country_code: "JMD",
        symbol: "$",
    },
    {
        country: "Japanese Yen",
        country_code: "JPY",
        symbol: "¥",
    },
    {
        country: "Jordanian Dinar",
        country_code: "JOD",
        symbol: "د.ا",
    },
    {
        country: "Kazakhstani Tenge",
        country_code: "KZT",
        symbol: "₸",
    },
    {
        country: "Kenyan Shilling",
        country_code: "KES",
        symbol: "Sh",
    },
    {
        country: "Kuwaiti Dinar",
        country_code: "KWD",
        symbol: "د.ك",
    },
    {
        country: "Kyrgyzstani Som",
        country_code: "KGS",
        symbol: "с",
    },
    {
        country: "Lao Kip",
        country_code: "LAK",
        symbol: "₭",
    },
    {
        country: "Latvian Lats",
        country_code: "LVL",
        symbol: "Ls",
    },
    {
        country: "Lebanese Pound",
        country_code: "LBP",
        symbol: "ل.ل",
    },
    {
        country: "Lesotho Loti",
        country_code: "LSL",
        symbol: "L",
    },
    {
        country: "Liberian Dollar",
        country_code: "LRD",
        symbol: "$",
    },
    {
        country: "Libyan Dinar",
        country_code: "LYD",
        symbol: "ل.د",
    },
    {
        country: "Lithuanian Litas",
        country_code: "LTL",
        symbol: "Lt",
    },
    {
        country: "Macanese Pataca",
        country_code: "MOP",
        symbol: "P",
    },
    {
        country: "Macedonian Denar",
        country_code: "MKD",
        symbol: "ден",
    },
    {
        country: "Malagasy Ariary",
        country_code: "MGA",
        symbol: "Ar",
    },
    {
        country: "Malawian Kwacha",
        country_code: "MWK",
        symbol: "MK",
    },
    {
        country: "Malaysian Ringgit",
        country_code: "MYR",
        symbol: "RM",
    },
    {
        country: "Maldivian Rufiyaa",
        country_code: "MVR",
        symbol: "Rf",
    },
    {
        country: "Mauritanian Ouguiya",
        country_code: "MRU",
        symbol: "UM",
    },
    {
        country: "Mauritian Rupee",
        country_code: "MUR",
        symbol: "₨",
    },
    {
        country: "Mexican Peso",
        country_code: "MXN",
        symbol: "$",
    },
    {
        country: "Moldovan Leu",
        country_code: "MDL",
        symbol: "L",
    },
    {
        country: "Mongolian Tögrög",
        country_code: "MNT",
        symbol: "₮",
    },
    {
        country: "Moroccan Dirham",
        country_code: "MAD",
        symbol: "د.م.",
    },
    {
        country: "Mozambican Metical",
        country_code: "MZN",
        symbol: "MT",
    },
    {
        country: "Myanmar Kyat",
        country_code: "MMK",
        symbol: "K",
    },
    {
        country: "Namibian Dollar",
        country_code: "NAD",
        symbol: "$",
    },
    {
        country: "Nepalese Rupee",
        country_code: "NPR",
        symbol: "₨",
    },
    {
        country: "Netherlands Antillean Guilder",
        country_code: "ANG",
        symbol: "ƒ",
    },
    {
        country: "New Taiwan Dollar",
        country_code: "TWD",
        symbol: "NT$",
    },
    {
        country: "New Zealand Dollar",
        country_code: "NZD",
        symbol: "$",
    },
    {
        country: "Nicaraguan Córdoba",
        country_code: "NIO",
        symbol: "C$",
    },
    {
        country: "Nigerian Naira",
        country_code: "NGN",
        symbol: "₦",
    },
    {
        country: "North Korean Won",
        country_code: "KPW",
        symbol: "₩",
    },
    {
        country: "Norwegian Krone",
        country_code: "NOK",
        symbol: "kr",
    },
    {
        country: "Omani Rial",
        country_code: "OMR",
        symbol: "ر.ع.",
    },
    {
        country: "Pakistani Rupee",
        country_code: "PKR",
        symbol: "₨",
    },
    {
        country: "Panamanian Balboa",
        country_code: "PAB",
        symbol: "B/.",
    },
    {
        country: "Papua New Guinean Kina",
        country_code: "PGK",
        symbol: "K",
    },
    {
        country: "Paraguayan Guaraní",
        country_code: "PYG",
        symbol: "₲",
    },
    {
        country: "Peruvian Sol",
        country_code: "PEN",
        symbol: "S/.",
    },
    {
        country: "Philippine Peso",
        country_code: "PHP",
        symbol: "₱",
    },
    {
        country: "Polish Złoty",
        country_code: "PLN",
        symbol: "zł",
    },
    {
        country: "Qatari Riyal",
        country_code: "QAR",
        symbol: "ر.ق",
    },
    {
        country: "Romanian Leu",
        country_code: "RON",
        symbol: "L",
    },
    {
        country: "Russian Ruble",
        country_code: "RUB",
        symbol: "₽",
    },
    {
        country: "Rwandan Franc",
        country_code: "RWF",
        symbol: "FRw",
    },
    {
        country: "Saint Helena Pound",
        country_code: "SHP",
        symbol: "£",
    },
    {
        country: "Samoan Tala",
        country_code: "WST",
        symbol: "T",
    },
    {
        country: "São Tomé and Príncipe Dobra",
        country_code: "STN",
        symbol: "Db",
    },
    {
        country: "Saudi Riyal",
        country_code: "SAR",
        symbol: "ر.س",
    },
    {
        country: "Serbian Dinar",
        country_code: "RSD",
        symbol: "дин",
    },
    {
        country: "Seychellois Rupee",
        country_code: "SCR",
        symbol: "₨",
    },
    {
        country: "Sierra Leonean Leone",
        country_code: "SLL",
        symbol: "Le",
    },
    {
        country: "Singapore Dollar",
        country_code: "SGD",
        symbol: "$",
    },
    {
        country: "Solomon Islands Dollar",
        country_code: "SBD",
        symbol: "$",
    },
    {
        country: "Somali Shilling",
        country_code: "SOS",
        symbol: "Sh",
    },
    {
        country: "South African Rand",
        country_code: "ZAR",
        symbol: "R",
    },
    {
        country: "South Korean Won",
        country_code: "KRW",
        symbol: "₩",
    },
    {
        country: "South Sudanese Pound",
        country_code: "SSP",
        symbol: "£",
    },
    {
        country: "Sri Lankan Rupee",
        country_code: "LKR",
        symbol: "₨",
    },
    {
        country: "Sudanese Pound",
        country_code: "SDG",
        symbol: "ج.س.",
    },
    {
        country: "Surinamese Dollar",
        country_code: "SRD",
        symbol: "$",
    },
    {
        country: "Swazi Lilangeni",
        country_code: "SZL",
        symbol: "E",
    },
    {
        country: "Swedish Krona",
        country_code: "SEK",
        symbol: "kr",
    },
    {
        country: "Swiss Franc",
        country_code: "CHF",
        symbol: "Fr",
    },
    {
        country: "Syrian Pound",
        country_code: "SYP",
        symbol: "£",
    },
    {
        country: "Tajikistani Somoni",
        country_code: "TJS",
        symbol: "SM",
    },
    {
        country: "Tanzanian Shilling",
        country_code: "TZS",
        symbol: "Sh",
    },
    {
        country: "Thai Baht",
        country_code: "THB",
        symbol: "฿",
    },
    {
        country: "Tongan Paʻanga",
        country_code: "TOP",
        symbol: "T$",
    },
    {
        country: "Trinidad and Tobago Dollar",
        country_code: "TTD",
        symbol: "$",
    },
    {
        country: "Tunisian Dinar",
        country_code: "TND",
        symbol: "د.ت",
    },
    {
        country: "Turkish Lira",
        country_code: "TRY",
        symbol: "₺",
    },
    {
        country: "Turkmenistani Manat",
        country_code: "TMT",
        symbol: "m",
    },
    {
        country: "Ugandan Shilling",
        country_code: "UGX",
        symbol: "Sh",
    },
    {
        country: "Ukrainian Hryvnia",
        country_code: "UAH",
        symbol: "₴",
    },
    {
        country: "United Arab Emirates Dirham",
        country_code: "AED",
        symbol: "د.إ",
    },
    {
        country: "United States Dollar",
        country_code: "USD",
        symbol: "$",
    },
    {
        country: "Uruguayan Peso",
        country_code: "UYU",
        symbol: "$U",
    },
    {
        country: "Uzbekistani So'm",
        country_code: "UZS",
        symbol: "лв",
    },
    {
        country: "Vanuatu Vatu",
        country_code: "VUV",
        symbol: "Vt",
    },
    {
        country: "Venezuelan Bolívar",
        country_code: "VES",
        symbol: "Bs",
    },
    {
        country: "Vietnamese Dong",
        country_code: "VND",
        symbol: "₫",
    },
    {
        country: "Western Samoan Tala",
        country_code: "WST",
        symbol: "T",
    },
    {
        country: "Yemeni Rial",
        country_code: "YER",
        symbol: "﷼",
    },
    {
        country: "Zambian Kwacha",
        country_code: "ZMW",
        symbol: "ZK",
    },
    {
        country: "Zimbabwean Dollar",
        country_code: "ZWL",
        symbol: "$",
    },
];

export const animateOptions = [
    { label: "No animation", value: "none" },
    { label: "Emitting", value: "emitting" },
    { label: "Bounce", value: "bounce" },
    { label: "Flash", value: "flash" },
    { label: "Rubber Band", value: "rubberBand" },
    { label: "Swing", value: "swing" },
    { label: "Tada", value: "tada" },
    { label: "Wobble", value: "wobble" },
    { label: "Jello", value: "jello" },
    { label: "Flip", value: "flip" },
] as const;

export const CART_CHANGE_EVENT = "cart:change";
export const CART_CHANGE_ANALYZED = "cart:analyzed";
export const CART_CHANGE_FETCH_EVENT = "cart:updated:fetch";

// emit cart events
export const EMIT_CART_UPDATED = "kefi-cart:updated";
export const EMIT_CART_CLOSED = "kefi-cart:closed";
export const EMIT_CART_OPENED = "kefi-cart:opened";

export const ADD_TO_CART_CLICKED = "kefi-bundles:addProducts";

// it detects whether cart is open or not
export const CART_STATE_CHANGED = "kefi_cart_state_changed";

// admin side form discard button click event
export const DISCARD_BUTTON_CLICKED = "discard-button-clicked";

export const METAL_BIRD_SHOPS = [
    "quickstart-f02489ba.myshopify.com",
    "metalbird-staging.myshopify.com",
    "bundletest21.myshopify.com",
    "hjgebrn.myshopify.com",
    "metalbirdusa-ge.myshopify.com",
    "metalbird.myshopify.com",
    "metalbirds-australia.myshopify.com",
    "metalbirduk.myshopify.com",
    "metalbird-canada.myshopify.com",
    "progress-bar-new-test.myshopify.com",
    "metalbirdnederland.myshopify.com",
    "metalbirdfrance.myshopify.com",
    "2bb5e5-83.myshopify.com",
    "new-kefi-aditya-2.myshopify.com",
    "dev-store-0118.myshopify.com",
    "gitpull.myshopify.com",
    "testbundle22.myshopify.com",
    "sdhieur.myshopify.com",
    "kashish-store-5.myshopify.com",
    "passionfruitshop.myshopify.com",
];
export const SPRAY_IT_INDIA = "es2jur-un.myshopify.com";
export const IS_METAL_BIRD_SHOP = METAL_BIRD_SHOPS.includes(
    window?.shopify?.config?.shop || window?.kefi_bundles?.shop || "",
);
export const SPRAY_IT_SHOPS = ["es2jur-un.myshopify.com", "1u194a-10.myshopify.com", "new-kefi-aditya-2.myshopify.com"];

export const getStoreContext = (standalone?: boolean) => {
    if (!standalone) return "";

    const locale = window?.kefi_bundles?.localization?.locale || "en";
    const country = window?.kefi_bundles?.localization?.country || "US";
    const language = locale.replace("-", "_").toUpperCase();
    return `@inContext(country: ${country}, language: ${language})`;
};

export function rgbToHex(color: string): string | null {
    const match = color.match(/^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([\d.]+))?\s*\)$/);

    if (!match) return null;

    const r = Math.min(255, Number(match[1]));
    const g = Math.min(255, Number(match[2]));
    const b = Math.min(255, Number(match[3]));
    const a = match[4] !== undefined ? Math.round(Number(match[4]) * 255) : null;

    const hex = (n: number) => n.toString(16).padStart(2, "0");

    return "#" + hex(r) + hex(g) + hex(b) + (a !== null ? hex(a) : "");
}

function hexToRgb(hex: string): [number, number, number] {
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((c) => c + c)
            .join(""); // expand shorthand #fff → #ffffff
    }
    const num = parseInt(hex, 16);
    return [
        (num >> 16) & 255, // R
        (num >> 8) & 255, // G
        num & 255, // B
    ];
}

function getLuminance(r: number, g: number, b: number): number {
    const a = [r, g, b].map((v) => {
        v = v / 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function getContrastRatio(color1: [number, number, number], color2: [number, number, number]): number {
    const lum1 = getLuminance(color1[0], color1[1], color1[2]);
    const lum2 = getLuminance(color2[0], color2[1], color2[2]);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}

function isReadable(bgColor: [number, number, number], textColor: [number, number, number]): boolean {
    const ratio = getContrastRatio(bgColor, textColor);
    return ratio >= 2.5; // WCAG recommended threshold
}

export async function getDefaultColors(
    DOMAIN: string,
    STOREFRONT_TOKEN: string,
): Promise<{ bgColor: string | null; textColor: string | null }> {
    const API_URL = `https://${DOMAIN}/api/2025-01/graphql.json`;
    const SCRAPER_API = "https://kefi-scrapper-486746463077.us-east4.run.app";

    try {
        // Fetch first product from Shopify
        const query = `
      {
        products(first: 1) {
          edges {
            node {
              title
              handle
            }
          }
        }
      }
    `;
        const res = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
            },
            body: JSON.stringify({ query }),
        });

        const json = (await res.json()) as {
            data: { products: { edges: { node: { title: string; handle: string } }[] } };
        };
        const products = json.data.products.edges.map((e) => e.node);

        if (!products.length) return { bgColor: null, textColor: null };

        const productUrl = `https://${DOMAIN}/products/${products[0].handle}`; //change  here

        // const productUrl = "https://www.7organica.com/collections/edible-oil/products/preminum-mustard-oil-1ltr";

        console._log("Product Url ", `https://${DOMAIN}/products/${products[0].handle}`);

        // Fetch scraper data
        const scraperRes = await fetch(`${SCRAPER_API}/?pageUrl=${encodeURIComponent(productUrl)}`);

        if (!scraperRes.ok) return { bgColor: null, textColor: null };

        const scraperData: any = await scraperRes.json();

        const bgColor = scraperData?.colors?.results?.[0]?.hex || null;
        let textColor = scraperData?.textColors?.[0]?.color || null;

        if (textColor?.startsWith("rgb")) {
            const hex = rgbToHex(textColor);
            if (hex) textColor = hex;
        }

        // Only return colors if readable
        if (bgColor && textColor) {
            const bgRgb = hexToRgb(bgColor);
            const textRgb = hexToRgb(textColor);
            if (!isReadable(bgRgb, textRgb)) {
                return { bgColor: null, textColor: null };
            }
        }

        return { bgColor, textColor };
    } catch (err) {
        console.error("Error getting default colors:", err);
        return { bgColor: null, textColor: null };
    }
}
interface CartShopConfig {
    enableVariants: boolean;
    cartItemSelector: string;
    customCartItemStyles?: { [key: string]: string };
    loaderDelay?: number;
    hideAttributes?: boolean;
    injectionPoint?: (cartItem: HTMLElement) => HTMLElement;
    debounceTime?: number;
    cartPageSelector?: string;
    observerSelector?: string;
    observeAttributes?: string[];
    targetOccurrence?: string;
    targetIndex?: number;
    skipUnchangedRender?: boolean;
    defaultOpen?: boolean;
}

export const SPORTS_TOP_URL = "sportstoplax.myshopify.com";
export const MAYUR_TEST_STORE = "ogtest1store.myshopify.com";
export const ADITYA_STORE = "new-kefi-aditya-2.myshopify.com";
export const COOLGEL_STORE = "d2f1bd.myshopify.com";
export const PURRBOTTLE = "puur-cl.myshopify.com";
export const NAGAIA = "thenagaia.myshopify.com";
export const AVIDDARTS = "one80-darts-supplies.myshopify.com";
export const BONMAXIE = "bon-maxie.myshopify.com";
export const SHOPS_WITH_MANY_VARIANTS = ["6d72c8.myshopify.com"];
export const IS_CUSTOM_CLICK_TO_ADD_GRID_SHOPS = [
    "4uis3d-t1.myshopify.com",
    "gitpull.myshopify.com",
    "teststr321.myshopify.com",
].includes(window?.shopify?.config?.shop || window?.kefi_bundles?.shop || "");
export const isLilSweetTreatStore = [
    "dev-store-0124.myshopify.com",
    MAYUR_TEST_STORE,
    "hellowstore13.myshopify.com",
    "ef8a23-ed.myshopify.com",
].includes(window?.shopify?.config?.shop || window?.kefi_bundles?.shop || "");
export const isDispensaryCoStore = [
    "dev-store-0121.myshopify.com",
    "04gsde-ui.myshopify.com",
    "bundletest55.myshopify.com",
    "test-bundle-29.myshopify.com",
].includes(window?.shopify?.config?.shop || window?.kefi_bundles?.shop || "");
export const isMeinSchoenerStore = ["mein-schoener-garten-shop.myshopify.com"].includes(
    window?.shopify?.config?.shop || window?.kefi_bundles?.shop || "",
);

export const CART_SHOPS_VARIANTS_INFO: Record<string, CartShopConfig> = {
    [SPORTS_TOP_URL]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        injectionPoint: (cartItem) => cartItem.querySelector(".product-option") || cartItem,
        debounceTime: 1000,
    },
    "d2f1bd.myshopify.com": {
        enableVariants: true,
        cartItemSelector: ".line-item",
        customCartItemStyles: {
            alignItems: "start",
        },
        loaderDelay: 1000,
        injectionPoint: (cartItem) => cartItem.querySelector(".line-item__info") || cartItem,
        debounceTime: 4000,
        cartPageSelector: ".order-summary__body .line-item",
    },
    [MAYUR_TEST_STORE]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-item__details") || cartItem,

        debounceTime: 1000,
    },
    [ADITYA_STORE]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-item__details") || cartItem,

        debounceTime: 1000,
    },
    [PURRBOTTLE]: {
        enableVariants: true,
        cartItemSelector: ".line-item",
        loaderDelay: 1000,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart__item") || cartItem,
        debounceTime: 4000,
        cartPageSelector: ".order-summary__body .line-item",
    },
    [NAGAIA]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        loaderDelay: 1000,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-column.cart-column--flex-group") || cartItem,
        debounceTime: 1000,
    },
    [AVIDDARTS]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        loaderDelay: 100,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-item__details") || cartItem,
        debounceTime: 100,
    },
    [BONMAXIE]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        loaderDelay: 100,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-item__product--info > :first-child") || cartItem,
        debounceTime: 100,
    },
    ["mein-schoener-garten-shop.myshopify.com"]: {
        enableVariants: true,
        cartItemSelector: '[class~="#product-card-min"], [class~="#cart-item"]',
        loaderDelay: 1000,
        hideAttributes: true,
        injectionPoint: (cartItem) =>
            cartItem.querySelector('[class~="#product-card-min-body"], [class~="#cart-item-product-info"]') || cartItem,
        debounceTime: 3000,
        observerSelector: "cart-drawer #modal-container-dialog",
        observeAttributes: ["open"],
    },
    ["1edi3i-wp.myshopify.com"]: {
        enableVariants: true,
        cartItemSelector: "cart-item",
        loaderDelay: 100,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".product-item-minimal__content-main-left") || cartItem,
        debounceTime: 100,
        targetOccurrence: "all",
    },
    ["jrnfnq-4b.myshopify.com"]: {
        enableVariants: true,
        cartItemSelector: ".cart-item",
        loaderDelay: 1000,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart-item__details") || cartItem,
        debounceTime: 1000,
        targetOccurrence: "all",
        skipUnchangedRender: true,
        defaultOpen: true,
    },
    ["tkc2022.myshopify.com"]: {
        enableVariants: true,
        cartItemSelector: ".cart__item",
        loaderDelay: 1000,
        hideAttributes: true,
        injectionPoint: (cartItem) => cartItem.querySelector(".cart__item-title") || cartItem,
        debounceTime: 1000,
        targetOccurrence: "all",
    },
};

export const injectCSS = (css: any) => {
    const style = document.createElement("style");
    style.innerHTML = css;
    document.head.appendChild(style);
};

export const executeJS = (userJS: any) => {
    try {
        const wrappedJS = `
      setTimeout(() => {
        try {
          ${userJS}
        } catch (err) {
          console.error("Custom JS runtime error:", err);
        }
      }, 0);
    `;

        new Function(wrappedJS)();
    } catch (err) {
        console.error("Custom JS failed to execute:", err);
    }
};

export const executeScopedJS = (userJS: string, formId: string) => {
    setTimeout(() => {
        const containers = document.querySelectorAll(`[data-form-id="${formId}"]`);
        if (containers.length == 0) {
            return;
        }
        const container = containers[containers.length - 1];
        const originalQS = document.querySelector.bind(document);
        const originalQSA = document.querySelectorAll.bind(document);

        document.querySelector = function (selector: any) {
            return container.querySelector(selector);
        };

        document.querySelectorAll = function (selector: any) {
            return container.querySelectorAll(selector);
        };

        try {
            eval(userJS);
        } catch (err) {
            console.error("Error in user code:", err);
        } finally {
            document.querySelector = originalQS;
            document.querySelectorAll = originalQSA;
        }
    }, 1000);
};

export const scopeCSS = (css: string, formId: string) => {
    const scope = `[data-form-id="${formId}"]`;

    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css);

    const scopedRules: string[] = [];

    const processRules = (rules: CSSRuleList) => {
        for (const rule of Array.from(rules)) {
            if (rule instanceof CSSStyleRule) {
                const selectors = rule.selectorText
                    .split(",")
                    .map((sel) => {
                        const s = sel.trim();

                        const descendant = `${scope} ${s}`;

                        // Only allow same-element if selector starts with . # or [
                        if (/^[.#\[]/.test(s)) {
                            return `${descendant}, ${scope}${s}`;
                        }

                        return descendant;
                    })
                    .join(", ");

                scopedRules.push(`${selectors} { ${rule.style.cssText} }`);
            } else if (rule instanceof CSSMediaRule) {
                const inner: string[] = [];

                for (const innerRule of Array.from(rule.cssRules)) {
                    if (innerRule instanceof CSSStyleRule) {
                        const selectors = innerRule.selectorText
                            .split(",")
                            .map((sel) => {
                                const s = sel.trim();
                                const descendant = `${scope} ${s}`;

                                if (/^[.#\[]/.test(s)) {
                                    return `${descendant}, ${scope}${s}`;
                                }

                                return descendant;
                            })
                            .join(", ");

                        inner.push(`${selectors} { ${innerRule.style.cssText} }`);
                    }
                }

                scopedRules.push(`@media ${rule.conditionText} { ${inner.join(" ")} }`);
            } else {
                scopedRules.push(rule.cssText);
            }
        }
    };

    processRules(sheet.cssRules);

    return scopedRules.join("\n");
};

export const injectCustomGlobalStyles = (css: string, formId: string) => {
    const existing = document.querySelector(`style[data-global-id="${formId}"]`);
    if (existing) return;

    const style = document.createElement("style");
    style.setAttribute("data-global-id", formId);
    style.innerHTML = css;
    document.head.appendChild(style);
};

export const injectScopedCSS = (css: string, formId: string) => {
    if (!css || !formId) return;

    let globalCSS = "";
    const cleanCSS = css.replace(/@global\s*\(([^)]*)\)\s*\{([\s\S]*?)\}/g, (match, selectors, content) => {
        globalCSS += `${selectors} { ${content} }\n`;
        return "";
    });

    if (globalCSS) {
        injectCustomGlobalStyles(globalCSS, formId);
    }

    const existing = document.querySelector(`style[data-form-id="${formId}"]`);
    if (existing) return;

    const style = document.createElement("style");
    style.setAttribute("data-form-id", formId);

    style.textContent = scopeCSS(cleanCSS, formId);

    document.head.appendChild(style);
};

export function getProductId(productId: string | number) {
    const strId = String(productId);

    // Split by "/" and get the last part
    const parts = strId.split("/");
    const lastPart = parts[parts.length - 1];

    // Return only the numeric part
    return lastPart;
}

export function migrateBBConfig(oldConfig: BundleBuilderConfigInterface): BundleBuilderConfigInterface {
    const { free_gift_step, steps, ...rest } = oldConfig;

    // If no free gift or not enabled → just remove it and return
    if (!free_gift_step || !free_gift_step.is_enabled) {
        return {
            ...rest,
            steps: [...steps],
        };
    }

    // Convert old free gift condition → new StepConditionType[]
    const convertedConditions: StepConditionType[] = [
        {
            basis: "items_count", // assuming free gift was based on product count
            type: free_gift_step.step_condition_type,
            limit: free_gift_step.product_count_limit,
            msg: free_gift_step.step_error_msg,
        },
    ];

    // Convert FreeGiftStepType → StepsType
    const freeGiftStepAsStep: StepsType = {
        step_label: free_gift_step.step_label,
        page_title: free_gift_step.page_title,
        page_subtitle: free_gift_step.page_subtitle,
        header_subtitle: undefined,
        bottom_subtitle: undefined,
        step_icon: free_gift_step.step_icon ?? null,
        step_content_type: "free_gift",
        product_selection: free_gift_step.product_selection,
        enable_subSteps: free_gift_step.enable_subSteps,
        subSteps: [],
        products: free_gift_step.products,
        collections: free_gift_step.collections,
        step_conditions: convertedConditions,
        fields: [],
        render_as_variants: free_gift_step.render_as_variants,
        show_step_conditions: true,
        show_banner: free_gift_step.show_banner,
        banner_desktop: free_gift_step.banner_desktop,
        banner_mobile: free_gift_step.banner_mobile,
        substep_rules_type: "no_rules",
    };

    return {
        ...rest,
        steps: [...steps, freeGiftStepAsStep],

        // Keep free_gift_step but disable it
        free_gift_step: {
            ...free_gift_step,
            is_enabled: false,
        },
    };
}

export function migratePlaceholderConfig(oldConfig: PlaceholderConfigInterface): PlaceholderConfigInterface {
    const { free_gift_step, steps, ...rest } = oldConfig;

    // If no free gift or not enabled → just return as is
    if (!free_gift_step || !free_gift_step.is_enabled) {
        return {
            ...rest,
            steps: [...steps],
        };
    }

    // Convert old free gift condition → new StepConditionType[]
    const convertedConditions: StepConditionType[] = [
        {
            basis: "items_count",
            type: free_gift_step.step_condition_type,
            limit: free_gift_step.product_count_limit,
            msg: free_gift_step.step_error_msg,
        },
    ];

    // Convert FreeGiftStepType → PlaceholderStepsType
    const freeGiftStepAsStep: PlaceholderStepsType = {
        step_label: free_gift_step.step_label,
        page_title: free_gift_step.page_title,
        page_subtitle: free_gift_step.page_subtitle,
        step_icon: free_gift_step.step_icon ?? null,
        step_content_type: "free_gift",
        product_selection: free_gift_step.product_selection,
        enable_subSteps: free_gift_step.enable_subSteps,
        subSteps: [],
        products: free_gift_step.products,
        collections: free_gift_step.collections,
        step_conditions: convertedConditions,
        render_as_variants: free_gift_step.render_as_variants,
        show_step_conditions: true,
        show_banner: free_gift_step.show_banner,
        banner_desktop: free_gift_step.banner_desktop,
        banner_mobile: free_gift_step.banner_mobile,
    };

    return {
        ...rest,
        steps: [...steps, freeGiftStepAsStep],

        // Keep free_gift_step but disable it
        free_gift_step: {
            ...free_gift_step,
            is_enabled: false,
        },
    };
}

export const extractNumericIds = (items: { id?: string }[] = []): string[] => {
    return items.map((item) => item?.id?.split("/").pop()).filter((id): id is string => Boolean(id));
};

export const buildResourcePickerQuery = ({
    products = [],
    collections = [],
    filters = [],
    includeUnlisted = false,
}: {
    products?: string[]; // product IDs
    collections?: string[]; // collection IDs
    filters?: Array<"specific" | "collection" | "all" | "exclude" | undefined>;
    includeUnlisted?: boolean; // also allow products with status "unlisted"
}) => {
    //  includeUnlisted ? "(status:active OR status:unlisted)"
    const queryParts: string[] = [includeUnlisted ? "status:active" : "status:active", "published_status:published"];

    if (filters.includes("all")) {
        return queryParts.join(" AND ");
    }

    if (filters.includes("specific") && products.length) {
        const productQuery = products.map((id) => `id:${id}`).join(" OR ");
        queryParts.push(`(${productQuery})`);
    }

    if (filters.includes("collection") && collections.length) {
        const collectionQuery = collections.map((id) => `collection_id:${id}`).join(" OR ");
        queryParts.push(`(${collectionQuery})`);
    }

    if (filters.includes("exclude") && products.length) {
        const excludeQuery = products.map((id) => `NOT id:${id}`).join(" AND ");
        queryParts.push(excludeQuery);
    }

    return queryParts.join(" AND ");
};

export const getInitialSelectedVariants = ({
    quantity,
    productId,
    variants,
    defaultVariantTypes = [],
}: {
    quantity: number;
    productId: string;
    variants: VariantsObj[];
    defaultVariantTypes?: DefaultVariantType[];
}): VariantsObj[] => {
    if (!variants?.length) return [];

    const fallbackVariant = variants.find((v) => v.availableForSale === true) || variants[0];

    const config = defaultVariantTypes?.find(
        (item) => getProductId(item.productID) === getProductId(productId) && item.variantIDs.length === quantity,
    );

    return Array.from({ length: quantity }).map((_, index) => {
        let variant = fallbackVariant;

        if (config?.variantIDs?.[index]) {
            const matched = variants.find((v) => v.id === config.variantIDs[index]);
            if (matched) variant = matched;
        }

        return {
            ...variant,
            copyPrice: variant.price,
        };
    });
};

export const flattenProducts = (products: ProductObj[], shouldExpand: boolean = false) => {
    if (!shouldExpand) return products;

    return products?.flatMap((product) => {
        const qty = product?.quantity || 1;

        return Array.from({ length: qty }, (_, i) => ({
            ...product,
            quantity: 1,
            _instanceId: `${product.id}-${i}`,
        }));
    });
};

export const bundleTypeNameOptions = [
    { id: "standard", label: "Standard" },
    { id: "bxgy", label: "BXGY" },
    { id: "volume", label: "Volume" },
    { id: "mixmatch", label: "Mix & Match" },
    { id: "fbt", label: "FBT" },
    { id: "product_add_on", label: "Product Add-on" },
    { id: "mixmatch_sectional", label: "Mix & Match Sectional" },
    { id: "product_add_on_popup", label: "Product Add-on Popup" },
    { id: "bundle_builder", label: "Build Your Own Box" },
    { id: "bb_placeholder", label: "Product Page Bundle Builder" },
    { id: "buy_n", label: "Buy N" },
];
